import { render, staticRenderFns } from "./LastPayments.vue?vue&type=template&id=2777625c"
import script from "./LastPayments.vue?vue&type=script&lang=js"
export * from "./LastPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports